import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import BPFPaymentModalUI from './BPFPaymentModalUI.js'

class BPFPaymentModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      billCount: '',
      billCountError: null,
      feeAmount: '',
      feeAmountError: null,
    }
  }

  render() {
    let feeAmountList = [
      { key: '100', value: '100' },
      { key: '500', value: '500' }
    ]
    return (
      <BPFPaymentModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        billCount={this.state.billCount}
        onBillCountChange={(event) => { this.setState({ billCount: event.target.value }) }}
        billCountError={this.state.billCountError}
        setBillCountError={(error) => { this.setState({ billCountError: error }) }}
        //
        feeAmount={this.state.feeAmount}
        onFeeAmountChange={(event) => { this.setState({ feeAmount: event.target.value }) }}
        feeAmountError={this.state.feeAmountError}
        setFeeAmountError={(error) => { this.setState({ feeAmountError: error }) }}
        feeAmountList={feeAmountList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/billPaymentFees`,
      this.onSubmitCallback, {
      billCount: this.state.billCount,
      feeAmountF: this.state.feeAmount
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(BPFPaymentModalSF)
